import "../styles/index.css"
import "../styles/print.css"
import "./htmx"
import "./hyperscript"
// import "./alpinejs"
import "cally"

(function () {
    let lastUuid = "";

    async function doFetch() {
        console.log("fetching")

        setTimeout(() => doFetch().catch(error => console.log(error)), 5000)

        const response = await fetch("/api/version")

        const data = await response.json() as { uuid: string }

        if (lastUuid !== data.uuid) {
            if (lastUuid !== "") {
                location.reload()
            }

            lastUuid = data.uuid
        }
    }

    doFetch().catch(error => console.log(error))

    document.addEventListener('keydown', (event) => {
      console.log(`Key: ${event.key}, Code: ${event.code}`, event)
  })
    document.addEventListener('keyup', (event) => {
      console.log(`Key: ${event.key}, Code: ${event.code}`, event)
  })
})();

